/* ── Sprig Supply Co. — theme.js ── */

/* NAV SCROLL */
window.addEventListener('scroll', () => {
  document.querySelector('.site-nav')?.classList.toggle('scrolled', window.scrollY > 60);
});

/* FADE-UP OBSERVER */
function observeFadeUps() {
  const obs = new IntersectionObserver((entries) => {
    entries.forEach((e, i) => {
      if (e.isIntersecting) {
        setTimeout(() => e.target.classList.add('visible'), i * 80);
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('.fade-up').forEach(el => obs.observe(el));
}
observeFadeUps();

/* FILTER TABS */
window.filterProducts = function(type, btn) {
  document.querySelectorAll('.filter-tab').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  document.querySelectorAll('.product-card').forEach(card => {
    const t = card.dataset.type;
    card.classList.toggle('hidden', type !== 'all' && t !== type);
  });
};

/* ── PRODUCT DATA HELPER ─────────────────────────────── */
function getProductDataFromCard(card) {
  // Sizes come from Shopify as JSON array of variant titles
  let sizes = [];
  try { sizes = JSON.parse(card.dataset.sizes || '[]'); } catch(e) {}
  // Filter out "Default Title" — Shopify uses this for products with no variants
  sizes = sizes.filter(s => s && s !== 'Default Title');

  let features = [];
  try { features = JSON.parse(card.dataset.features || '[]'); } catch(e) {}

  return {
    id:        card.dataset.productId,
    handle:    card.dataset.handle,
    name:      card.dataset.name,
    price:     card.dataset.price,
    type:      card.dataset.type,
    img:       card.dataset.img,
    desc:      card.dataset.desc,
    sizes,
    features,
    variantId: card.dataset.variantId,
    // All variant IDs so we can match by size name
    variants:  (() => {
      try { return JSON.parse(card.dataset.variants || '[]'); } catch(e) { return []; }
    })(),
  };
}

/* ── MODAL STATE ─────────────────────────────────────── */
let currentProduct = null;
let selectedSize   = null;
let selectedVariantId = null;
let qty            = 1;

/* ── OPEN MODAL ──────────────────────────────────────── */
window.openModal = function(el) {
  // el can be the card itself or a child element — walk up to find the card
  const card = el.closest
    ? (el.dataset.productId ? el : el.closest('[data-product-id]'))
    : el;

  if (!card) return;
  const modal = document.getElementById('productModal');
  if (!modal) return;

  currentProduct    = getProductDataFromCard(card);
  selectedSize      = null;
  selectedVariantId = currentProduct.variantId; // default to first variant
  qty               = 1;
  document.getElementById('qtyNum').textContent = 1;

  modal.querySelector('#modalImg').src             = currentProduct.img;
  modal.querySelector('#modalImg').alt             = currentProduct.name;
  modal.querySelector('#modalCategory').textContent = currentProduct.type === 'hat' ? 'Headwear' : 'Apparel';
  modal.querySelector('#modalTitle').textContent   = currentProduct.name;
  modal.querySelector('#modalPrice').textContent   = currentProduct.price;
  modal.querySelector('#modalDesc').textContent    = currentProduct.desc;

  // Size buttons
  const so = modal.querySelector('#sizeOptions');
  const sizeSection = modal.querySelector('#sizeSection');
  so.innerHTML = '';

  if (currentProduct.sizes.length === 0) {
    // No real size variants — hide size section, use default variant
    sizeSection.style.display = 'none';
    selectedSize = 'One Size';
  } else if (currentProduct.sizes.length === 1) {
    // Single size — auto-select it, hide section
    sizeSection.style.display = 'none';
    selectedSize = currentProduct.sizes[0];
  } else {
    // Multiple sizes — show buttons
    sizeSection.style.display = 'block';
    currentProduct.sizes.forEach((s, idx) => {
      const b = document.createElement('button');
      b.className   = 'size-btn';
      b.textContent = s;
      b.dataset.variantIdx = idx;
      b.onclick = () => {
        so.querySelectorAll('.size-btn').forEach(x => x.classList.remove('selected'));
        b.classList.add('selected');
        selectedSize = s;
        // If variants array available, pick the matching variant ID
        if (currentProduct.variants.length > idx) {
          selectedVariantId = String(currentProduct.variants[idx].id);
        }
      };
      so.appendChild(b);
    });
  }

  const mf = modal.querySelector('#modalFeatures');
  mf.innerHTML = currentProduct.features.map(f => `<div class="modal-feat">${f}</div>`).join('');

  const addBtn = modal.querySelector('#addCartBtn');
  addBtn.textContent = 'Add to Cart';
  addBtn.classList.remove('success');

  modal.classList.add('open');
  document.body.style.overflow = 'hidden';
};

window.closeModal = function() {
  document.getElementById('productModal')?.classList.remove('open');
  document.body.style.overflow = '';
};

window.closeModalOnBg = function(e) {
  if (e.target === document.getElementById('productModal')) window.closeModal();
};

window.changeQty = function(delta) {
  qty = Math.max(1, qty + delta);
  document.getElementById('qtyNum').textContent = qty;
};

/* ── QUICK ADD (bypasses modal for single-variant products) ── */
window.quickAdd = async function(e, cardEl) {
  e.stopPropagation();
  const card = cardEl.closest('[data-product-id]');
  if (!card) return;

  const product = getProductDataFromCard(card);

  // If product has multiple sizes, open modal instead
  if (product.sizes.length > 1) {
    window.openModal(card);
    return;
  }

  // Single variant or no variants — add directly
  const btn = cardEl;
  const originalHTML = btn.innerHTML;
  btn.innerHTML = '<span style="font-size:11px;letter-spacing:0.1em">Adding…</span>';

  const variantId = product.variantId;
  if (!variantId) {
    btn.innerHTML = originalHTML;
    showToast('Product not available');
    return;
  }

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
    });

    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || 'Cart error');
    }

    btn.innerHTML = '✓ Added';
    await updateCartDrawer();
    showToast(`${product.name} added to cart`);
    setTimeout(() => {
      btn.innerHTML = originalHTML;
      window.openCart();
    }, 800);
  } catch (err) {
    console.error('Quick add error:', err);
    btn.innerHTML = originalHTML;
    showToast(err.message || 'Something went wrong');
  }
};

/* ── ADD TO CART (from modal) ────────────────────────── */
window.addToCart = async function() {
  if (!currentProduct) return;

  // If multi-size and none selected, shake the size buttons
  if (currentProduct.sizes.length > 1 && !selectedSize) {
    const so = document.getElementById('sizeOptions');
    so.style.animation = 'none';
    so.offsetHeight; // reflow
    so.style.animation = 'shake 0.4s ease';
    showToast('Please select a size');
    return;
  }

  const addBtn = document.getElementById('addCartBtn');
  addBtn.textContent = 'Adding…';
  addBtn.disabled = true;

  const variantId = parseInt(selectedVariantId || currentProduct.variantId, 10);

  if (!variantId || isNaN(variantId)) {
    addBtn.textContent = 'Add to Cart';
    addBtn.disabled = false;
    showToast('Product not available — check back soon');
    return;
  }

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty }),
    });

    if (!res.ok) {
      const errData = await res.json().catch(() => ({}));
      throw new Error(errData.description || 'Could not add to cart');
    }

    addBtn.textContent = '✓ Added!';
    addBtn.classList.add('success');
    await updateCartDrawer();
    showToast(`${currentProduct.name} added to cart`);

    setTimeout(() => {
      window.closeModal();
      window.openCart();
      addBtn.disabled = false;
    }, 700);

  } catch (err) {
    console.error('Add to cart error:', err);
    addBtn.textContent = 'Add to Cart';
    addBtn.disabled = false;
    addBtn.classList.remove('success');
    showToast(err.message || 'Something went wrong — try again');
  }
};

/* ── CART DRAWER ─────────────────────────────────────── */
window.openCart = function() {
  document.getElementById('cartOverlay')?.classList.add('open');
  document.getElementById('cartDrawer')?.classList.add('open');
  document.body.style.overflow = 'hidden';
  updateCartDrawer();
};

window.closeCart = function() {
  document.getElementById('cartOverlay')?.classList.remove('open');
  document.getElementById('cartDrawer')?.classList.remove('open');
  document.body.style.overflow = '';
};

async function updateCartDrawer() {
  try {
    const res  = await fetch('/cart.js');
    const cart = await res.json();
    renderCartDrawer(cart);
  } catch (e) {
    console.error('Cart fetch error:', e);
  }
}

function renderCartDrawer(cart) {
  const countEl  = document.getElementById('cartCount');
  const itemsEl  = document.getElementById('cartItems');
  const footerEl = document.getElementById('cartFooter');
  const subtotal = document.getElementById('cartSubtotal');
  const total    = document.getElementById('cartTotal');

  const count = cart.item_count || 0;
  if (countEl) countEl.textContent = count;

  if (!count) {
    if (itemsEl)  itemsEl.innerHTML = `<div class="cart-empty"><div class="cart-empty-icon">🦆</div>Your cart is empty</div>`;
    if (footerEl) footerEl.style.display = 'none';
    return;
  }

  if (footerEl) footerEl.style.display = 'block';
  const fmt = (cents) => `$${(cents / 100).toFixed(2)}`;
  if (subtotal) subtotal.textContent = fmt(cart.total_price);
  if (total)    total.textContent    = fmt(cart.total_price);

  if (itemsEl) {
    itemsEl.innerHTML = cart.items.map(item => `
      <div class="cart-item">
        <div class="cart-item-img">
          <img src="${item.image || ''}" alt="${item.product_title}" onerror="this.style.display='none'"/>
        </div>
        <div class="cart-item-info">
          <div class="cart-item-name">${item.product_title}</div>
          <div class="cart-item-meta">${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title + ' · ' : ''}Qty: ${item.quantity}</div>
          <div class="cart-item-row">
            <div class="cart-item-price">${fmt(item.line_price)}</div>
            <button class="cart-item-remove" onclick="removeCartItem('${item.key}')">Remove</button>
          </div>
        </div>
      </div>`).join('');
  }
}

window.removeCartItem = async function(key) {
  try {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }),
    });
    updateCartDrawer();
  } catch(e) {
    console.error('Remove item error:', e);
  }
};

window.checkout = function() {
  window.location.href = '/checkout';
};

/* ── TOAST ───────────────────────────────────────────── */
function showToast(msg) {
  const t = document.getElementById('toast');
  if (!t) return;
  document.getElementById('toastMsg').textContent = msg;
  t.classList.add('show');
  clearTimeout(t._timeout);
  t._timeout = setTimeout(() => t.classList.remove('show'), 2800);
}

/* ── SHAKE ANIMATION (size not selected) ─────────────── */
const shakeStyle = document.createElement('style');
shakeStyle.textContent = `
  @keyframes shake {
    0%,100% { transform: translateX(0); }
    20%      { transform: translateX(-6px); }
    40%      { transform: translateX(6px); }
    60%      { transform: translateX(-4px); }
    80%      { transform: translateX(4px); }
  }
`;
document.head.appendChild(shakeStyle);

/* ── INIT ────────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', async () => {
  try {
    const res  = await fetch('/cart.js');
    const cart = await res.json();
    const el   = document.getElementById('cartCount');
    if (el) el.textContent = cart.item_count || 0;
  } catch (e) { /* silent */ }
});
